import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdd = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.37516 10.6252H4.5835V9.37516H9.37516V4.5835H10.6252V9.37516H15.4168V10.6252H10.6252V15.4168H9.37516V10.6252Z",
		fill: "currentColor"
	})
});
export default SvgAdd;
